"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Redux = __importStar(require("redux"));
var isListener_1 = __importDefault(require("./utils/isListener"));
var composeEnhancersWithDevtools = function (devtoolOptions) {
    if (devtoolOptions === void 0) { devtoolOptions = {}; }
    var disabled = devtoolOptions.disabled, options = __rest(devtoolOptions, ["disabled"]);
    /* istanbul ignore next */
    return !disabled &&
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(options)
        : Redux.compose;
};
function default_1(_a) {
    var _this = this;
    var redux = _a.redux, models = _a.models;
    var combineReducers = redux.combineReducers || Redux.combineReducers;
    var createStore = redux.createStore || Redux.createStore;
    var initialStates = typeof redux.initialStates !== 'undefined' ? redux.initialStates : {};
    // Allows passing in of reducer functions, rather than models.
    // While not recommended,
    // this can be used for migrating a Redux codebase or configuring different Redux extensions.
    this.reducers = redux.reducers;
    // combine models to generate reducers
    this.mergeReducers = function (nextReducers) {
        if (nextReducers === void 0) { nextReducers = {}; }
        // merge new reducers with existing reducers
        _this.reducers = __assign(__assign({}, _this.reducers), nextReducers);
        if (!Object.keys(_this.reducers).length) {
            // no reducers, just return state
            return function (state) { return state; };
        }
        return combineReducers(_this.reducers);
    };
    this.createModelReducer = function (model) {
        var modelBaseReducer = model.baseReducer;
        var modelReducers = {};
        for (var _i = 0, _a = Object.keys(model.reducers || {}); _i < _a.length; _i++) {
            var modelReducer = _a[_i];
            var action = isListener_1.default(modelReducer)
                ? modelReducer
                : model.name + "/" + modelReducer;
            modelReducers[action] = model.reducers[modelReducer];
        }
        // use the `state = model.state` argument convention popularized
        var combinedReducer = function (state, action) {
            if (state === void 0) { state = model.state; }
            if (typeof modelReducers[action.type] === 'function') {
                return modelReducers[action.type](state, action.payload, action.meta);
            }
            return state;
        };
        _this.reducers[model.name] = !modelBaseReducer
            ? combinedReducer
            : function (state, action) {
                return combinedReducer(modelBaseReducer(state, action), action);
            };
    };
    // initialize model reducers
    for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
        var model = models_1[_i];
        this.createModelReducer(model);
    }
    // rootReducers is a way to setup middleware hooks at the base of your root reducer.
    // Unlike middleware, the return value is the next state.
    // If undefined, the state will fallback to the initial state of reducers.
    this.createRootReducer = function (rootReducers) {
        if (rootReducers === void 0) { rootReducers = {}; }
        var mergedReducers = _this.mergeReducers();
        if (Object.keys(rootReducers).length) {
            return function (state, action) {
                var rootReducerAction = rootReducers[action.type];
                if (rootReducerAction) {
                    return mergedReducers(rootReducerAction(state, action), action);
                }
                return mergedReducers(state, action);
            };
        }
        return mergedReducers;
    };
    var rootReducer = this.createRootReducer(redux.rootReducers);
    var middlewares = Redux.applyMiddleware.apply(Redux, redux.middlewares);
    var enhancers = composeEnhancersWithDevtools(redux.devtoolOptions).apply(void 0, __spreadArrays(redux.enhancers, [middlewares]));
    this.store = createStore(rootReducer, initialStates, enhancers);
    return this;
}
exports.default = default_1;
//# sourceMappingURL=redux.js.map